import { ParsedResponse } from "../types";

export function parse(content: string): ParsedResponse {
  try {
    const data = typeof content === "string" ? JSON.parse(content) : content;

    // Validate content
    if (typeof data.content !== "string" || data.content.length === 0) {
      return {
        error: true,
        message: "Content must be a non-empty string",
        rawContent: content,
      };
    }
    //as of right now, don't do anything with teh parsing.  just return the data as is.
    return data;
  } catch {
    // If parsing fails, treat the content as raw markdown
    return {
      data: {
        content,
        tags: [],
        scope: "private",
        views: 0,
      },
    };
  }
}
